import { useCallback, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";

import { useHQs } from "../../hooks/queries";
import { useCreateHQs, useUpdateHQs } from "../../hooks/mutation";
import { toast } from "react-toastify";
import { FaAngleLeft, FaAngleRight, FaEdit } from "react-icons/fa";
import { PAGE_SIZE } from "../Utils/constant";
import TextInput from "../common/TextInput";

const HeadQuarters = () => {
  const [page, setPage] = useState(1);

  const [isEdit, setIsEdit] = useState(false);
  const [HQ, setHQ] = useState(null);
  const [search, setSearch] = useState(null);
  const { data } = useHQs(isEdit, search, page);
  const [HQsData, setHQsData] = useState();
  const [totalCount, setTotalCount] = useState(0);
  useEffect(() => {
    if (data) {
      setHQsData(data.data);
      setTotalCount(data.count);
    }
  }, [data]);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Code: "",
      Description: "",
      HQUser: "",
      HQPass: "",
      Active: true,
    },
  });

  useEffect(() => {
    if (HQ) {
      reset({
        Code: HQ.Code,
        Description: HQ.Description,
        HQUser: HQ.HQUser,
        HQPass: HQ.HQPass,
        Active: HQ.Active,
      });
    }
  }, [HQ, reset]);

  const onNextPage = useCallback(() => {
    setPage((old) => old + 1);
  }, []);
  const onPrevPage = useCallback(() => {
    setPage((old) => old - 1);
  }, []);

  const onSuccess = useCallback((_data) => {
    toast.success("Success");
  }, []);
  const onError = useCallback((err) => {
    console.log("error", err);
  }, []);

  const onAddNew = () => {
    reset({
      Code: "",
      Description: "",
      HQUser: "",
      HQPass: "",
      Active: true,
    });
    setIsEdit(true);
  };

  const OnCancel = () => {
    setIsEdit(false);
    setHQ();
  };

  const { mutate: createHQs, isPending: isCreating } = useCreateHQs(
    onSuccess,
    onError
  );

  const { mutate: updateHQs, isPending: isUpdating } = useUpdateHQs(
    onSuccess,
    onError
  );

  const OnCreate = useCallback(
    (data) => {
      if (HQ) {
        updateHQs({ ...data, ID: HQ.HQID });
      } else {
        createHQs(data);
      }
    },
    [HQ, createHQs, updateHQs]
  );
  const OnSearch = useCallback(
    (data) => {
      setSearch(data);
    },
    [setSearch]
  );

  return (
    <>
      {isEdit ? (
        <div className="driver-patent-edit-content mt-4 rounded-lg">
          <div className="flex justify-between mb-2">
            <div>
              <p>Code</p>
            </div>
            <div className="flex justify-between w-35">
              <Controller
                control={control}
                name="Code"
                rules={{
                  required: "Code is required",
                }}
                render={({ field: { value, onChange } }) => (
                  <TextInput
                    value={value}
                    onChange={onChange}
                    className="custom-input rounded-lg w-100"
                    error={errors.Code?.message}
                  />
                )}
              />
            </div>
          </div>

          <div className="flex justify-between mb-2">
            <div>
              <p>Description</p>
            </div>
            <div className="flex justify-between w-35">
              <Controller
                control={control}
                name="Description"
                rules={{
                  required: "Description is required",
                }}
                render={({ field: { value, onChange } }) => (
                  <TextInput
                    value={value}
                    onChange={onChange}
                    className="custom-input rounded-lg w-100"
                    error={errors.Description?.message}
                  />
                )}
              />
            </div>
          </div>
          <div className="flex justify-between mb-2">
            <div>
              <p>Hq User</p>
            </div>
            <div className="flex justify-between w-35">
              <Controller
                control={control}
                name="HQUser"
                rules={{
                  required: "Hq User is required",
                }}
                render={({ field: { value, onChange } }) => (
                  <TextInput
                    value={value}
                    onChange={onChange}
                    className="custom-input rounded-lg w-100"
                    error={errors.HQUser?.message}
                  />
                )}
              />
            </div>
          </div>

          <div className="flex justify-between mb-2">
            <div>
              <p>Hq Pass</p>
            </div>
            <div className="flex justify-between w-35">
              <Controller
                control={control}
                name="HQPass"
                rules={{
                  required: "Hq Pass is required",
                }}
                render={({ field: { value, onChange } }) => (
                  <TextInput
                    value={value}
                    onChange={onChange}
                    className="custom-input rounded-lg w-100"
                    error={errors.HQPass?.message}
                  />
                )}
              />
            </div>
          </div>

          <div className="flex justify-between mb-2">
            <div>
              <p>Active</p>
            </div>
            <div className="flex justify-between w-35">
              <Controller
                control={control}
                name="Active"
                render={({ field: { value, onChange } }) => (
                  <ToggleSwitch
                    value={value}
                    onChange={(_value) => onChange(!value)}
                  />
                )}
              />
            </div>
          </div>
          <div className="flex gap-4 mt-4 save-button">
            <button
              disabled={isCreating | isUpdating}
              onClick={handleSubmit(OnCreate)}
              className="justify-between p-2 pr-20 pl-20 rounded-lg mr-1 flex items-center custom-blue-button"
            >
              <span>{HQ ? "Update" : "Create"}</span>
            </button>
            <div>
              <div
                onClick={OnCancel}
                className="justify-between pl-20 pr-20 p-2 rounded-lg flex items-center custom-white-button"
              >
                <span>Cancel</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="flex ">
            <h5 className="mb-0">HQ List</h5>
            <button
              className="justify-between rounded-lg ml-1 flex items-center custom-blue-button border-none"
              onClick={onAddNew}
            >
              <span>Add New</span>
            </button>
          </div>

          <SearchBar setSearch={setSearch} OnSearch={OnSearch} />

          <table className="table-auto w-full mt-4 border border-gray-200">
            <thead>
              <tr className="bg-gray-100 cursor-pointer">
                <th className="px-4 py-2 border">ID</th>
                <th className="px-4 py-2 border">Code</th>
                <th className="px-4 py-2 border">Description</th>
                <th className="px-4 py-2 border">Hq User</th>
                <th className="px-4 py-2 border">Hq Pass</th>
                <th className="px-4 py-2 border">Active</th>
                <th className="px-4 py-2 border">Edit</th>
              </tr>
            </thead>
            <tbody>
              {HQsData &&
                HQsData.map((HQ) => (
                  <tr key={HQ.HQID} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{HQ.HQID}</td>
                    <td className="px-4 py-2 border">{HQ.Code}</td>
                    <td className="px-4 py-2 border">{HQ.Description}</td>
                    <td className="px-4 py-2 border">{HQ.HQUser}</td>
                    <td className="px-4 py-2 border">{HQ.HQPass}</td>
                    <td className="px-4 py-2 border">
                      {HQ.Active == "1" ? "Active" : "Disabled"}
                    </td>
                    <td className="px-4 py-2 border cursor-point">
                      <FaEdit
                        onClick={() => {
                          setHQ(HQ);
                          setIsEdit(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="pagination-container">
            <div className="pagination-content">
              <div>
                <p className="pagination-text">
                  Showing <span>{(page - 1) * PAGE_SIZE + 1}</span> to{" "}
                  <span>{Math.min(totalCount, page * PAGE_SIZE)}</span> of{" "}
                  <span>{totalCount}</span> results
                </p>
              </div>
              <div>
                <nav className="pagination-nav">
                  <button
                    onClick={onPrevPage}
                    disabled={page == 1}
                    className={`pagination-item ${page == 1 ? "disabled" : ""}`}
                  >
                    <FaAngleLeft className="pagination-icon" />
                  </button>
                  <button
                    onClick={onNextPage}
                    disabled={page * PAGE_SIZE > totalCount}
                    className={`pagination-item ${
                      page * PAGE_SIZE > totalCount ? "disabled" : ""
                    }`}
                  >
                    <FaAngleRight className="pagination-icon" />
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HeadQuarters;

const ToggleSwitch = ({ value, onChange }) => {
  const onChangeHandler = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <label className="switch">
      <input
        checked={value ? true : false}
        onChange={onChangeHandler}
        type="checkbox"
      />
      <span className="slider round"></span>
    </label>
  );
};

const SearchBar = ({ setSearch, OnSearch }) => {
  const {
    control: searchControl,
    handleSubmit: handleSearchSubmit,
    reset: searchReset,
  } = useForm({
    defaultValues: {
      type: "HQID",
      which: "contains",
      text: "",
    },
  });

  return (
    <div className="flex mt-4 items-center gap-4 condition-bar">
      <div className="flex items-center">
        <p className="mb-0">Look For:</p>
        <div className="flex justify-between w-10 ml-1">
          <Controller
            control={searchControl}
            name="type"
            render={({ field: { value, onChange } }) => (
              <select
                className="custom-input rounded-lg cursor-pointer"
                value={value}
                onChange={onChange}
              >
                <option value={"HQID"}>Hqid</option>
                <option value={"Code"}>Code</option>
                <option value={"Description"}>Description</option>
                <option value={"HQUser"}>Hq USer</option>
                <option value={"HQPass"}>Hq Pass</option>
                <option value={"Active"}>Active</option>
              </select>
            )}
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <p className="mb-0">Which:</p>
        <div className="flex justify-between w-10 ml-1">
          <Controller
            control={searchControl}
            name="which"
            render={({ field: { value, onChange } }) => (
              <select
                className="custom-input rounded-lg cursor-pointer"
                value={value}
                onChange={onChange}
              >
                <option value="contains">contains</option>
                <option value="starts with">starts with</option>
                <option value="equals">equals</option>
                <option value="ends with">ends with</option>
              </select>
            )}
          />
        </div>
        <div className="">
          <Controller
            control={searchControl}
            name="text"
            rules={{
              required: "Required",
            }}
            render={({ field: { value, onChange } }) => (
              <input
                type="text"
                value={value}
                onChange={onChange}
                className="custom-input rounded-lg w-100 "
              />
            )}
          />
        </div>
      </div>
      <div className="flex">
        <div>
          <button
            onClick={handleSearchSubmit(OnSearch)}
            className="justify-between rounded-lg flex items-center w-30 custom-search-button border-none"
          >
            <span>Search</span>
          </button>
        </div>
        <div>
          <button
            onClick={() => {
              searchReset({
                type: "HQID",
                which: "contains",
                text: "",
              });
              setSearch(null);
            }}
            className="justify-between rounded-lg ml-1 flex items-center custom-reset-button"
          >
            <span>Reset</span>
          </button>
        </div>
      </div>
    </div>
  );
};
